import { gql } from '@apollo/client';

// TODO: once a backend carrying the `deploymentStatus` field (see src/server/typedefs.ts
// in SP3Backend) is deployed and reachable, run `yarn codegen` and switch index.tsx to the
// generated types instead of the hand-written ones below — codegen introspects a live
// schema, so it cannot pick up a field that is not deployed anywhere yet. Same situation
// as `deploymentInfo` in src/layout/queries.ts.

export type ServiceDeployment = {
  name: string;
  platform: string;
  workload: string | null;
  commit: string | null;
  branch: string | null;
  build: string | null;
  source: string | null;
  revision: string | null;
  startedAt: string | null;
  liveSince: string | null;
  ready: string | null;
  note: string | null;
};

export type DeploymentStatusResult = {
  deploymentStatus: {
    environment: string;
    project: string;
    namespace: string;
    fetchedAt: string;
    services: ServiceDeployment[];
  };
};

export const DEPLOYMENT_STATUS_QUERY = gql`
  query DeploymentStatus {
    deploymentStatus {
      environment
      project
      namespace
      fetchedAt
      services {
        name
        platform
        workload
        commit
        branch
        build
        source
        revision
        startedAt
        liveSince
        ready
        note
      }
    }
  }
`;
